import React, { useEffect, useState } from 'react';
import MasterLayout from '../../layouts/MasterLayout';
import ThemeBreadcrumb from '../../components/themes/ThemeBreadcrumb';
import AppNotification from '../../helpers/AppNotification';
import Paginate from '../../components/paginate/Paginate';
import TransactionFee from '../../models/TransactionFee';
import HomeAdminCardMoney from "../../components/homeAdmin/HomeAdminCardMoney";


function FeeTransactionPage(props) {
    const [totalFee, setTotalFee] = useState(0);
    const [totalTransaction, setTotalTransaction] = useState(0);

    useEffect(() => {
        TransactionFee.getReport().then((res) => {
            setTotalFee(res.data.total_fee_today);
            setTotalTransaction(res.data.total_transaction_today);
        }).catch((err) => {
            AppNotification.showError('Lấy dữ liệu thất bại!');
        })
    }, [])

    // paginate
    const [perPage, setPerPage] = useState(25);
    const [page, setPage] = useState(1);
    const [meta, setMeta] = useState({});
    const changePage = (page) => {
        setPage(page);
    }
    const handleSetPage = (number) => {
        setPage(page + number);
    }

    const [data, setData] = useState([]);

    useEffect(() => {
        TransactionFee.getAll(
            {
                page: page,
                perPage: perPage
            }
        ).then((res) => {
            setData(res.data);
            setMeta(res.meta);
        }).catch((err) => {
            console.log(err);
            AppNotification.showError('Lấy dữ liệu thất bại!');
        })
    }, [page])

    const handleChangeperPage = (e) => {
        setPerPage(e.target.value);
        setPage(1);
    }


    return (
        <MasterLayout>
            <ThemeBreadcrumb title="Thống kê phí giao dịch" />
            <div className='row'>
                <div className='col-xl-12'>
                    <div className='row'>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng số phí giao dịch trong ngày :'} value={parseInt(totalFee).toLocaleString("en-US") + ' VNĐ'} />
                        </div>
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                            <HomeAdminCardMoney title={'Tổng số giao dịch trong ngày :'} value={totalTransaction + ' Lần'} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Thống kê phí giao dịch</h4>
                        </div>
                        <div className="card-body">
                            <div className='table-responsive'>
                                <div id="example3_wrapper" className="dataTables_wrapper no-footer">
                                    <div className='row mb-3'>
                                        <div className='col-md-3 d-flex align-items-end'>
                                            <div className="dataTables_length" id="example3_length">
                                                <label>
                                                    Hiển thị{" "}
                                                    <select
                                                        name="example3_length"
                                                        aria-controls="example3"
                                                        className=""
                                                        value={perPage}
                                                        onChange={(e) => handleChangeperPage(e)}
                                                    >
                                                        <option value={1}>1</option>
                                                        <option value={25}>25</option>
                                                        <option value={100}>100</option>
                                                    </select>{" "}
                                                    dữ liệu.
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <table
                                        id="example3"
                                        className="display dataTable no-footer"
                                        style={{ width: '100%' }}
                                        role="grid"
                                        aria-describedby="example3_info"
                                    >
                                        <thead>
                                            <tr role="row">
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Name: activate to sort column ascending"
                                                    style={{ width: "80px" }}
                                                >
                                                    ID
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Name: activate to sort column ascending"
                                                    style={{ width: "220px" }}
                                                >
                                                    TÀI KHOẢN
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Department: activate to sort column ascending"
                                                >
                                                    NGÂN HÀNG
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Gender: activate to sort column ascending"
                                                >
                                                    GÓI VIP
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Education: activate to sort column ascending"
                                                >
                                                    SỐ LƯỢT CHUYỂN KHOẢN / TỔNG
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Mobile: activate to sort column ascending"
                                                >
                                                    SỐ TIỀN ĐÃ TRẢ / TỔNG
                                                </th>
                                                <th
                                                    className="sorting"
                                                    tabIndex={0}
                                                    aria-controls="example3"
                                                    rowSpan={1}
                                                    colSpan={1}
                                                    aria-label="Mobile: activate to sort column ascending"
                                                >
                                                    THỜI GIAN GIAO DỊCH
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                data.map((item, key) => (
                                                    <tr key={key} role="row" className="odd">
                                                        <td>
                                                            <div className="d-flex text-warning">
                                                                {item.user_bank_account_id}
                                                            </div>
                                                        </td>
                                                        <td className='text-warning'>
                                                            <div className='row'>
                                                                <div className='col-12'>
                                                                    <span className='text-primary'>{item.bank_number}</span> <br />
                                                                    <span>{item.bank_username}</span>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td className='text-warning'>{item.name}</td>
                                                        <td className='text-warning'>
                                                            {
                                                                item.package_type !== 'ALL' ? "Gói Thường "
                                                                    : "Gói Vip "
                                                            }
                                                            {
                                                                item.package_name === 'basic' ? "Cơ bản"
                                                                    : item.package_name === 'vip1' ? "1"
                                                                        : item.package_name === 'vip2' ? "2"
                                                                            : item.package_name === 'vip3' ? "3"
                                                                                : ""
                                                            }
                                                        </td>
                                                        <td><span>{item.total_transaction_today} / {item.total_transaction_until_now} (Lần)</span></td>
                                                        <td><span>{parseInt(item.total_fee_today).toLocaleString("en-US")} / {parseInt(item.total_fee_until_now).toLocaleString("en-US")} (VNĐ)</span></td>
                                                        <td className='text-warning'>{item.date}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </table>
                                    <Paginate meta={meta} changePage={changePage} page={page} handleSetPage={handleSetPage} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </MasterLayout>
    );
}

export default FeeTransactionPage;